const NAVBAR_DATA = [
  {
    id: 1,
    label: 'Home',
    path: '/'
  },
  {
    id: 2,
    label: 'About Us',
    path: '#about-us'
  },
  {
    id: 3,
    label: 'Special',
    path: '#special'
  },
  {
    id: 4,
    label: 'Menu',
    path: '#menu'
  },
  {
    id: 5,
    label: 'Blogs',
    path: '#blogs'
  },
  {
    id: 6,
    label: 'Book Now',
    path: '/book-now',
    isBtnNav: true
  }
];
export default NAVBAR_DATA;
